import CatalogItem from "@components/Actions/CatalogItems/Base";
import Icon from "@components/Atoms/Icon";
import t from "@ext/localization/locale/translate";
import { DisabledReason } from "@ui-kit/Tooltip";
import type { ReactNode } from "react";

const CatalogExport = ({ disabled, children }: { disabled: boolean; children?: () => ReactNode }) => {
	const label = (
		<>
			<Icon code="file-output" />
			{t("export.name")}
		</>
	);

	// Unavailable export is a plain item, not a sub-menu trigger: `aria-disabled` keeps a trigger reachable,
	// but Radix still opens its sub-menu on hover and ArrowRight.
	if (disabled)
		return (
			<CatalogItem
				renderLabel={(Item) => (
					<DisabledReason reason={t("export-disabled")}>
						<Item>{label}</Item>
					</DisabledReason>
				)}
			/>
		);

	return <CatalogItem renderLabel={(Item) => <Item>{label}</Item>}>{children}</CatalogItem>;
};

export default CatalogExport;
